"use client";

import { useEffect } from "react";

export default function GlobalError({
  error,
  reset
}: {
  readonly error: Error & { readonly digest?: string };
  readonly reset: () => void;
}) {
  useEffect(() => {
    // Sentry.captureException(error); // Removed
    // You can add alternative error logging here if needed, e.g., console.error(error);
    console.error("GlobalError caught:", error);
  }, [error]);

  return (
    <html lang='en'>
      <body>
        <h2>Something went wrong!</h2>
        <p>{error.message}</p>
        <button onClick={reset}>Try again</button>
      </body>
    </html>
  );
}
